export const removeProbitInfoFromtitle = (title: string) => {
  if (!title) {
    return "";
  }
  return title.toString().split("Fit -")[0].trim();
};
